{
  "responseShape": "சேவையக பதில் எதிர்பார்த்த வடிவத்துடன் பொருந்தவில்லை — புதுப்பிக்கவும்.",
  "badRequest": "தவறான கோரிக்கை. உங்கள் உள்ளீட்டைச் சரிபார்க்கவும்.",
  "forbidden": "இந்தச் செயலைச் செய்ய உங்களுக்கு அனுமதி இல்லை.",
  "facilityRequired": "இந்தத் தொகுதியைப் பயன்படுத்த, தலைப்பில் ஒரு வசதியைத் தேர்ந்தெடுக்கவும்.",
  "notFound": "வளம் கண்டறியப்படவில்லை.",
  "conflict": "வளம் ஏற்கனவே உள்ளது.",
  "validation": "சரிபார்ப்புப் பிழை.",
  "tooManyRequests": "மிக அதிக கோரிக்கைகள். பிறகு மீண்டும் முயற்சிக்கவும்.",
  "serverError": "சேவையகப் பிழை. பிறகு மீண்டும் முயற்சிக்கவும்.",
  "unexpected": "எதிர்பாராத பிழை ஏற்பட்டது.",
  "network": "பிணையப் பிழை. உங்கள் இணைப்பைச் சரிபார்க்கவும்.",
  "requestSetup": "பிழை ஏற்பட்டது. மீண்டும் முயற்சிக்கவும்.",
  "sessionExpired": "உங்கள் அமர்வு காலாவதாகிவிட்டது. மீண்டும் உள்நுழையவும்."
}
